import defaultSchema from './default.schema';

export default {
  ...defaultSchema,
  title: 'user',
  type: 'object',
  properties: {
    login: {
      type: 'string',
      title: 'Login *',
      fieldRequired: true
    },
    profile: {
      type: 'object',
      title: 'Profil',
      properties: {
        type: {
          title: 'Typ konta',
          type: 'number',
          fieldRequired: true
        },
        firstName: {
          title: 'Imię',
          type: 'string',
          fieldRequired: true,
          maxLength: 500
        },
        lastName: {
          title: 'Nazwisko',
          type: 'string',
          fieldRequired: true,
          maxLength: 500
        },
        birthDate: {
          title: 'Data urodzenia',
          type: 'string',
          format: 'date',
          validFunc:
            ' $methods.dateDiff($value, $methods.now()).ms < 0 &&  $methods.dateDiff( "1900-01-01", $value).ms < 0',
          fieldRequired: true,
          validationMessages: {
            validFunc: 'Proszę wpisać poprawną datę urodzenia'
          }
        },
        email: {
          title: 'Adres e-mail',
          type: 'string',
          format: 'email',
          maxLength: 255,
          calc: {
            when: 'this.email === ""',
            func: 'null'
          }
        },
        phoneNumber: {
          title: 'Numer telefonu',
          type: 'string',
          maxLength: 500
        },
        gender: {
          title: 'Płeć',
          type: 'number',
          fieldRequired: 'this.type === "CLIENT"'
        },
        confirmReason: {
          title: 'Powód akceptacji',
          type: 'string',
          fieldRequired: true
        },
        woj: {
          title: 'Województwo',
          type: 'string',
          fieldRequired: true
        },
        pow: {
          title: 'Powiat',
          type: 'string',
          fieldRequired: true
        },
        gmi: {
          title: 'Gmina',
          type: 'string',
          fieldRequired: true
        },
        terc: {
          title: 'Kod TERC',
          type: 'string',
          fieldRequired: true,
          minLength: 6
        },
        city: {
          title: 'Miejscowość',
          type: 'string',
          fieldRequired: true
        },
        simc: {
          title: 'Miejscowość',
          type: 'string',
          fieldRequired: true
        },
        street: {
          title: 'Ulica',
          type: 'string',
          fieldRequired: true
        },
        ulic: {
          title: 'Ulica',
          type: 'string',
          fieldRequired: true
        },
        postalCode: {
          title: 'Kod pocztowy',
          type: 'string',
          format: 'kod',
          fieldRequired: true,
          validationMessages: {
            format: 'Niepoprawny kod pocztowy'
          }
        },
        homeNumber: {
          title: 'Numer budynku',
          type: 'string',
          fieldRequired: true,
          maxLength: 500
        },
        localNumber: {
          title: 'Numer lokalu',
          type: 'string',
          fieldRequired: false,
          maxLength: 500
        },
        mainImage: {
          title: 'Zdjęcie',
          type: 'number'
        },
        confirmReasonDescription: {
          title: 'Powód akceptacji dodatkowe informacje',
          type: 'string',
          fieldRequired: false,
          maxLength: 500
        }
      }
    }
  }
};
